import { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { injectHtmlLinksInText } from '@/lib/utils/injectHtmlLinksInText';

export type DefaultPopupProps = {
  title: string | ReactNode;
  description: string | ReactNode;
  buttonLabel: string;
  links?: string[];
  cancelLabel?: string;
  onCancel?: () => void;
  onButtonClick?: () => void;
};

type Props = DefaultPopupProps & {
  isOpen: boolean;
  onClose: () => void;
};

export const DefaultPopup = ({
  title,
  description,
  buttonLabel,
  isOpen,
  onClose,
  links,
  cancelLabel,
  onButtonClick,
  onCancel,
}: Props) => {
  // Process links only if description is a string
  let processedDescription = description;
  if (typeof description === 'string' && links) {
    processedDescription = injectHtmlLinksInText(description, links);
  }

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      onClose();
    }
  };

  const handleCancelClick = () => {
    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  };
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        className="w-11/12 max-w-[425px] bg-primary py-10 text-center sm:w-full"
        //prevent close on click outside
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="pb-6">{title}</DialogTitle>
          {typeof processedDescription === 'string' ? (
            <DialogDescription
              dangerouslySetInnerHTML={{ __html: processedDescription }}
            />
          ) : (
            <DialogDescription>{processedDescription}</DialogDescription>
          )}
        </DialogHeader>

        {(buttonLabel || cancelLabel) && (
          <DialogFooter className="flex justify-center gap-4">
            {cancelLabel && (
              <Button variant="outline" onClick={handleCancelClick}>
                {cancelLabel}
              </Button>
            )}
            {buttonLabel && (
              <Button
                type="submit"
                onClick={handleButtonClick}
                variant="secondary"
              >
                {buttonLabel}
              </Button>
            )}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
